export const customRules = {
	phone: (context, ...args) => {
		return context.value.validated
	},
}

export const customMessages = {}
